import { cn } from '@/lib/utils';

/** «xatAjuda.com» com «.com» em peso mais leve. */
export function BrandName({ name, className }: { name: string; className?: string }) {
  const match = name.match(/^(.*?)(\.com)$/i);
  if (!match) {
    return <span className={className}>{name}</span>;
  }
  return (
    <span className={className}>
      {match[1]}
      <span className="font-medium tracking-tight text-white/90">{match[2]}</span>
    </span>
  );
}

type SiteBrandLogoProps = {
  name: string;
  className?: string;
};

/** Logo tipográfica do site (header / footer). */
export function SiteBrandLogo({ name, className }: SiteBrandLogoProps) {
  return (
    <BrandName
      name={name}
      className={cn(
        'inline-block whitespace-nowrap font-poppins font-bold tracking-tight text-white',
        className
      )}
    />
  );
}
